const s = {
  name: "TanzanianShilling",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,17c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v1h2v-1c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v0.8c0,1.1,0.6,2.2,1.7,2.7
			l1.8,0.9c0.3,0.2,0.6,0.5,0.6,0.9V23c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1v-1h-2v1c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3v-0.8
			c0-1.1-0.6-2.2-1.7-2.7l-1.8-0.9c-0.3-0.2-0.6-0.5-0.6-0.9V17z"/>
		<path class="st0" d="M10,16h2v10h2V16h2v-2h-6V16z"/>
		<path class="st0" d="M24,14v12h2v-4c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v4h2v-4c0-1.7-1.3-3-3-3c-0.4,0-0.7,0.1-1,0.2V14H24z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as TanzanianShilling
};
